import { PageNotFoundComponent as IGPageNotFoundComponent } from '@gridscale/ingrid/views/page-not-found';
import { Component, OnInit, inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { getLastUrl, getNavigationCount } from '../../@store/router/router.selector';
import { withLatestFrom } from 'rxjs';

@Component({
    imports: [IGPageNotFoundComponent],
    selector: 'app-page-not-found',
    templateUrl: './page-not-found.component.html',
    styleUrls: ['./page-not-found.component.scss']
})
export class PageNotFoundComponent implements OnInit {
  #store = inject(Store);

  lastUrl?: string;

  ngOnInit() {
    this.#store.select(getLastUrl).pipe(
      withLatestFrom(this.#store.select(getNavigationCount))
    ).subscribe(([lastUrl, navCount]) => {
      if (navCount > 1) {
        this.lastUrl = lastUrl
      } else {
        this.lastUrl = undefined;
      }
    });
  }

}
